function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrawio = function SvgDrawio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    x: 2,
    y: 2,
    rx: 1.12,
    style: {
      fill: "#f08705"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.861 9.168 3.02-3.187L30 16.094V28.88A1.12 1.12 0 0 1 28.88 30H11.316l-5.385-5.407Z",
    style: {
      fill: "#df6c0c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.24 17.96h-3.294l-3.071-5.32h.2a1.12 1.12 0 0 0 1.12-1.12V6.76a1.12 1.12 0 0 0-1.12-1.12H12.92a1.12 1.12 0 0 0-1.12 1.12v4.76a1.12 1.12 0 0 0 1.12 1.12h.205l-3.071 5.32H6.76a1.12 1.12 0 0 0-1.12 1.12v4.76a1.12 1.12 0 0 0 1.12 1.12h6.16a1.12 1.12 0 0 0 1.12-1.12v-4.76a1.12 1.12 0 0 0-1.12-1.12h-.927l3.072-5.32h1.87l3.071 5.32h-.926a1.12 1.12 0 0 0-1.12 1.12v4.76a1.12 1.12 0 0 0 1.12 1.12h6.16a1.12 1.12 0 0 0 1.12-1.12v-4.76a1.12 1.12 0 0 0-1.12-1.12",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgDrawio;